<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      class="purchaseReceivingEdit"
      :close-on-click-modal="false"
      title="条码打印"
      width="1000px"
      top="5vh">
    <div class="editTitle">物料明细</div>
    <el-button :disabled="!selection.length" type="primary" style="margin-bottom: 10px" @click="PrintAllBarCode">批量打印</el-button>
    <el-table
        ref="table"
        :data="tableData"
        border
        @select="select"
        @select-all="select">
      <el-table-column type="selection" align="center" label="#" prop="selection"/>
      <el-table-column 
          prop="materialNo" 
          align="center" 
          label="物料编号" 
          show-overflow-tooltip 
          width="150"/>
      <el-table-column 
          prop="materialName" 
          align="center" 
          label="物料描述" 
          show-overflow-tooltip 
          width="150"/>
      <el-table-column prop="specification" align="center" label="规格型号" width="150"/>
      <el-table-column prop="unitName" align="center" label="单位" width="100"/>
      <el-table-column prop="receiptQuantity" align="center" label="数量" width="100"/>
      <el-table-column prop="minPackageQuantity" align="center" label="最小包装数" width="100"/>
      <el-table-column prop="boxQuantity" align="center" label="装箱数量" width="100"/>
      <el-table-column align="center" label="标签数" width="100">
        <template slot-scope="scope">
          <span v-if="!scope.row.minPackageQuantity">0</span>
          <span v-else>{{Math.ceil(((scope.row.receiptQuantity)/(scope.row.minPackageQuantity)))}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="箱标签数" width="100">
        <template slot-scope="scope">
          <span v-if="!scope.row.boxQuantity||!scope.row.receiptQuantity||!scope.row.minPackageQuantity">0</span>
          <span v-else>{{Math.ceil((((scope.row.receiptQuantity)/(scope.row.minPackageQuantity))/(scope.row.boxQuantity)))}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="manufactureDate" align="left" label="生产日期" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.manufactureDate===null"/>
          <span v-else>{{scope.row.manufactureDate.substring(0, 10)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="expiredDate" align="left" label="失效日期" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.expiredDate === null"/>
          <span v-else>{{scope.row.expiredDate.substring(0, 10)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="note" align="center" width="160"/>
      <el-table-column label="操作" fixed="right" align="center" prop="action">
        <template slot-scope="scope">
          <el-button type="primary" @click="printBarCode(scope.row.pkid)">打印</el-button>
        </template>
      </el-table-column>
    </el-table>
    <tag-print-modal ref="tagPrint"/>
  </el-dialog>
</template>
<script>
  import TagPrintModal from "../TagPrint/TagPrintIndex";
  export default {
    name:"PurchaseReceivingDetails",
    components:{ TagPrintModal },
    data() {
      return {
        dialogVisible:false,
        pkid:"",
        tableData:[],
        selection:[],
        ids:[],
      };
    },
    methods:{
      open(id) {
        this.pkid = id;
        this.dialogVisible = true;
        this.getData();
      },

      //获取物料详情
      getData() {
        this.$http.get("basic",`deliveryBills/${this.pkid}`).then((res)=>{
          console.log(res);
          if(res.data) {
            this.tableData = res.data.billDetails;
          }
          
        });
      },

      //选择
      select(selection) {
        this.selection = selection;
        this.ids = [];
        selection.forEach((item)=>{
          this.ids.push(item.pkid);
        });
      },

      printBarCode(val) {
        let data ={
          id:val,
        };
        this.$http.get("basic", "deliveryBillDetails/printsn",data).then((res) => {
          // let blob = new Blob([res.data], {type: "application/json"});
          // let pdfUrl = window.URL.createObjectURL(blob);
          // window.open(pdfUrl, "__blank");
          if(res.success) {
            console.log(res.data);
            this.$refs.tagPrint.open(res.data);
          }
          
        });
      },


      //批量打印标签
      PrintAllBarCode() {
        console.log(this.ids);
        this.$http.post("basic","deliveryBillDetails/printsnBatch",this.ids).then((res)=>{
          if(res.success) {
            console.log(res.data);
            this.$refs.tagPrint.open(res.data);
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
.purchaseReceivingEdit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.purchaseReceivingEdit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.purchaseReceivingEdit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.purchaseReceivingEdit .el-divider--horizontal {
  margin: 10px 0;
}

.purchaseReceivingEdit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

// 加载效果水平垂直居中
.el-loading-spinner {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
}

// 标题
.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 5px;
}
</style>